import { z } from 'zod';

export const idoConfigSchema = z.object({
  title: z.string(),
  type: z.string(),
  symbol: z.string(),
  idoTokenPrecision: z.number(),
  totalSupply: z.string(),
  projectValuation: z.string(),
  initialCirculatingSupply: z.string(),
  initialMarketCapInUSD: z.string(),
  idoStartingPriceInUSD: z.string(),
  allocationInUsd: z.string(),
  allocationInIdoToken: z.string(),
  vesting: z.string(),
  developmentVerifierUrl: z.string(),
  productionVerifierUrl: z.string(),
  startGradientColor: z.string(),
  endGradientColor: z.string(),
  image: z.string(),
});
